<template>
    <div class="user-bmi">
      <div class="informationbox" v-if="bmiData">  
        <img class="infoicon" src="@/assets/icon/noahfitinfo.svg" :alt="$t('noahfit.bmi.info_icon_alt')" @click="showInfo = true" />
 
          <div v-if="showInfo" class="modal-backdrop" @click.self="showInfo = false">
            <div class="modal-content info">
              <h2>{{ $t('noahfit.bmi.info_title') }}</h2>
              <p>{{ $t('noahfit.bmi.info_p1') }}<br><br>{{ $t('noahfit.bmi.info_p2') }}</p>
            </div>
          </div>
          
        <div> 
            <h3 style="color: #106E35;">{{ $t('noahfit.bmi.daily_need_title') }}</h3> 
            <p>{{ $t('noahfit.bmi.calories_label') }} <b>{{ bmiData.dailycal }} {{ $t('noahfit.bmi.kcal_suffix') }}</b></p>
            <p>{{ $t('noahfit.bmi.protein_label') }} {{ bmiData.dailyprotein }} {{ $t('noahfit.bmi.gram_suffix') }}</p>
            <p>{{ $t('noahfit.bmi.carbon_label') }} {{ bmiData.dailycarbon }} {{ $t('noahfit.bmi.gram_suffix') }}</p> 
            <p>{{ $t('noahfit.bmi.calc_date_label') }} {{ formatDateTime(bmiData.created_at) }}</p>  
        </div> 
        <button @click="showModal = true">{{ $t('noahfit.bmi.recalculate') }}</button>
      </div>
   
      <div v-if="showModal" class="modal-backdrop" @click.self="showModal = false">
        <div class="modal-content">
          <button class="modal-close" @click="showModal = false">×</button>
          <h4>{{ $t('noahfit.bmi.calc_modal_title') }}</h4>
          <ModalForm @submit="submitForm" :initialForm="bmiData || {}" />
        </div>
      </div>
    </div>
  </template>
   
  <script>
  import axios from 'axios';
  import { eventBus } from "@/utils/eventBus";  
  import ModalForm from './ModalForm.vue';
  
  export default {
    name: 'UserBmi',
    components: {
      ModalForm
    },
    data() {
      return {
        bmiData: null,
        showModal: false,
        showInfo: false
      };
    },
    mounted() {
      this.fetchBmiData();
    },
    methods: {
      async fetchBmiData() {
        try {
          const res = await axios.get('/promo/user/bmi');
          if (res.data) {
            this.bmiData = res.data;
          } else {
            this.showModal = true;  
          }
        } catch (err) {
          console.error('Veri alınamadı:', err);
        }
      },
    
      async submitForm(formData) {
        try {
          const res = await axios.post('/promo/user/bmi', formData);
          this.bmiData = res.data;
          this.showModal = false;
          eventBus.emit("reloadFit");
        } catch (err) {
          console.error('Hesaplama hatası:', err);
        }
      }, 
    }
  };
  </script>
  
  <style scoped>
  .informationbox{
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
 .user-bmi {
  max-width: 1080;
  margin: auto;
  padding: 120px 0 0 0;
} 
p{
  padding: 0;
  margin: 0;
}

button {
  margin-top: 12px; 
  background-color: #1a310d;
  border: none;
  cursor: pointer;
}
 
.modal-backdrop {
  position: fixed;
  inset: 0;  
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
 
.modal-content {
  position: relative;
  background: #050505;
  padding: 32px;
  border-radius: 10px;
  border: #0B3018 solid 1px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: popupSlide 0.25s ease-out;
}
 
@keyframes popupSlide {
  0% {
    transform: scale(0.95);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
 
.modal-close {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: color 0.2s ease;
}

.modal-close:hover {
  color: #000;
}
.infoicon{
   max-width: 6rem; 
   opacity: 0.5;
   cursor: pointer;
}
.infoicon:hover{ 
   opacity: 0.8;
}

.modal-content.info {
  background: #050505; 
  max-width: 500px;
  line-height: 1.6;
}

.modal-content.info h2 {
  margin: 0;
  color: #106E35;
  font-size: 1.6rem;
  font-weight: 300;
}

.modal-content.info p {
  margin: 12px 0 0;
  font-size: 14px;
}

  </style>
  